<template>
  <div>
    <v-container fluid>
      <v-row dense class="pb-0">
        <v-col cols="3">
          <date-range :from.sync="from" :to.sync="to" v-model="dateDisplay" @change="refresh()" hide-details option="Last 30 days"/>
        </v-col>
        <v-col cols="3">
          <v-autocomplete label="Process" dense outlined hide-details :items="processes" item-text="name" item-value="id" v-model="processId"/>
        </v-col>
        <v-col class="text-right pr-2">
          <v-btn icon @click="printHtml('Distillation activity', report())"><v-icon>mdi-printer</v-icon></v-btn>
          <v-tooltip bottom open-delay="1000" v-if="company.allowCSVExport">
            <template v-slot:activator="{on}">
              <v-btn icon @click="exportCSV" v-on="on"><v-icon>mdi-download</v-icon></v-btn>
            </template>
            Export as CSV file
          </v-tooltip>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mx-4 pa-4 overflow-y" height="calc(100vh - 184px)">
      <span v-html="report()"/>
    </v-card>

  </div>
</template>

<script>
import fileSaver from 'file-saver';
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsDistillationActivity',
  mixins: [printHtml],
  data() {
    return {
      from: null,
      to: null,
      dateDisplay: '',
      processes: [{name:'All processes',id:null},{name:'No process',id:''},{divider:true}],
      processId: null,
      distillations: [],
      loading: true,
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    },
    processName() {
      const process = this.processes.find(process => process.id === this.processId);
      return process ? process.text : '';
    },
    distillationsList() {
      if (this.processId === null)
        return this.distillations;
      return this.distillations.filter(distillation =>
        (this.processId === '' && distillation.processId === null) || (this.processId !== '' && this.processId === distillation.processId)
      );
    }
  },
  async created() {
    this.$emit('name', 'Distilling activity')
    if (this.$route.query.from && this.$route.query.to) {
      this.from = this.$route.query.from;
      this.to = this.$route.query.to;
    }
    if (this.$route.query.processId)
      this.processId = this.$route.query.processId;

    this.$lazyListLoad(this.processes, 'processes2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]);
    this.loading = false;
  },
  methods: {
    async refresh() {
      this.loading = true;
      const results = await this.$apiCall(`query ReportsDistillationActivity($from:Date!,$to:Date!) {
                                                distillationActivity(from:$from,to:$to) {
                                                  id,date,processId,processName,
                                                  inputs{type,vesselName,volume},
                                                  outputs{type,vesselName,volume}
                                                }
                                              }`,
                                          {from:this.from,to:this.to});
      if (!results.error)
        this.distillations = results.data.distillationActivity;
      this.loading = false;

    },

    report() {
    const lines = [
                    `<style>
                      @page {size:landscape}
                      .reports-distillation-activity {font-family: Roboto, sans-serif; font-size:14px;width:100%;border-spacing:0}
                      .reports-distillation-activity th {height:36px;padding:0 16px}
                      .reports-distillation-activity td {height:36px;padding:0 16px}
                      .reports-distillation-activity .title {font-size:18px;text-transform:uppercase}
                      .reports-distillation-activity .sup-title {font-weight:normal;font-size:22px}
                      .reports-distillation-activity .sub-title {font-weight:normal;height:inherit;padding-bottom:20px;font-size:14px}
                      .reports-distillation-activity .header th {border-bottom:1px solid #000;margin-bottom:20px}
                      .reports-distillation-activity .text-left {text-align:left}
                      .reports-distillation-activity .text-right {text-align:right}
                    </style>
                    <table class="reports-distillation-activity">
                     <thead>
                        <tr>
                          <th colspan="6" class="sup-title">${this.company.name}</th>
                        </tr>
                        <tr>
                          <th colspan="6" class="title">Distilling activity</th>
                        </tr>
                        <tr>
                           <th colspan="6" class="sub-title">${this.dateDisplay}</th>
                        </tr>
                        <tr class="header">
                            <th width="15%" class="text-left">Date</th>
                            <th width="20%" class="text-left">Process</th>
                            <th width="10%" class="text-left">In/Out</th>
                            <th width="20%" class="text-left">Type</th>
                            <th width="20%" class="text-left">Vessel</th>
                            <th width="15%" class="text-left text-right">Volume</th>
                          </tr>
                      </thead>
                      <tbody>`
    ];
    for (const distillation of this.distillationsList) {
      let i = 0;
      for (const input of distillation.inputs) {
        lines.push(`<tr>`);
        if (i === 0) {
          lines.push(`<td>${this.$formatDate(distillation.date)}</td>`);
          lines.push(`<td>${distillation.processName ? distillation.processName : ''}</td>`);
        }
        else {
          lines.push(`<td/>`)
          lines.push(`<td/>`)
        }
        lines.push(`<td>IN</td>`);
        lines.push(`<td>${input.type}</td>`);
        lines.push(`<td>${input.vesselName}</td>`);
        lines.push(`<td class="text-right">${input.volume}</td>`);
        lines.push(`</tr>`);
        i++
      }
      for (const output of distillation.outputs) {
        lines.push(`<td/>`)
        lines.push(`<td/>`)
        lines.push(`<td>OUT</td>`);
        lines.push(`<td>${output.type}</td>`);
        lines.push(`<td>${output.vesselName}</td>`);
        lines.push(`<td class="text-right">${output.volume}</td>`);
        lines.push(`</tr>`);
      }
    }
    lines.push(`</tbody>`);
    lines.push(`</table>`);
    return lines.join('');
    },

    exportCSV() {
      const lines = [ `"${this.company.name}",,,,,`,
                      `"Distilling activity",,,,,`,
                      `"${this.dateDisplay}",,,,,`,
                      `"Date","Process","In/Out","Type","Vessel","Volume"`
                    ];
      for (const distillation of this.distillationsList) {
        let i = 0;
        for (const input of distillation.inputs) {
          let line = i === 0 ? `"${distillation.date}","${distillation.processName ? distillation.processName : ''}",` : `,,`;
          line += `"IN","${input.type}","${input.vesselName}","${input.volume}"`;
          lines.push(line);
          i++
        }
        for (const output of distillation.outputs)
          lines.push(`,,"OUT","${output.type}","${output.vesselName}","${output.volume}"`);
      }

      // Write CSV file
      const blob = new Blob([lines.join('\r\n')], {type: "text/plain;charset=utf-8"});
      fileSaver.saveAs(blob, 'Distilling activity.csv');
    }
  }
}
</script>